import ChipLabel, { ChipLabelProps } from 'omakase/ChipLabel/ChipLabel';
import React from 'react';

import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
} from '../utils/OmakasePolymorphicComponent';

export interface NumericChipLabelOwnProps {
  /**
   * The active / current number (e.g., as in 2/4)
   */
  current: number;
  /**
   * The total number (e.g., as in 2/4)
   */
  total: number;
}

const NumericChipLabelDefaultElement = 'div';
type NumericChipLabelTypeGuard = 'div' | 'span';

export type NumericChipLabelProps = NumericChipLabelOwnProps & ChipLabelProps;

const NumericChipLabel: OmakasePolymorphicComponent<
  NumericChipLabelProps,
  typeof NumericChipLabelDefaultElement,
  NumericChipLabelTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof NumericChipLabelDefaultElement>(
    {
      component,
      current,
      total,
      ...rest
    }: OmakasePolymorphicComponentProps<NumericChipLabelProps, E, NumericChipLabelTypeGuard>,
    ref: React.Ref<HTMLElement> | undefined
  ) => {
    const Component: React.ElementType = component || NumericChipLabelDefaultElement;

    return (
      <ChipLabel ref={ref} component={Component} {...rest}>
        {current} / {total}
      </ChipLabel>
    );
  }
);

export default NumericChipLabel;
